import { Fragment, useState } from "react";
import { Combobox, Transition } from "@headlessui/react";
// import { CheckIcon, ChevronUpDownIcon } from "@heroicons/react/20/solid";
import clsx from "clsx";
import { IoIosArrowDown } from "react-icons/io";

export default function SelectBox({
  selected = {},
  errorMsg,
  setSelected,
  data,
  name,
}) {
  const [query, setQuery] = useState("");
  const filteredData =
    query === ""
      ? data
      : data.filter((person) =>
          person.username
            .toLowerCase()
            .replace(/\s+/g, "")
            .includes(query.toLowerCase().replace(/\s+/g, ""))
        );

  return (
    <div className=" w-full">
      <Combobox value={selected} onChange={setSelected}>
        <div className="relative">
          <div
            className={clsx(
              "relative w-full cursor-default overflow-hidden rounded-lg border text-left dark:bg-secondary-dark-bg  py-[10px] px-3 z-0 sm:text-sm",
              {
                "border-red-600": errorMsg,
                "dark:border-white ": selected.id,
              }
            )}
          >
            <Combobox.Input
              placeholder={name}
              className={clsx(
                "w-full border-none  pr-10 outline-none leading-5 text-gray-900 dark:text-white text-base focus:ring-0 z-0 dark:bg-transparent"
              )}
              displayValue={(person) => person.username}
              onChange={(event) => setQuery(event.target.value)}
            />
            <Combobox.Button className="absolute inset-y-0 right-0 flex items-center pr-2">
              <IoIosArrowDown className="dark:text-white text-gray-400" />
            </Combobox.Button>
          </div>
          <Transition
            as={Fragment}
            leave="transition ease-in duration-100"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
            afterLeave={() => setQuery("")}
          >
            <Combobox.Options className="absolute mt-1 max-h-60 w-full overflow-auto rounded-md bg-gray-50 dark:bg-main-dark-bg z-50 text-base shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none sm:text-sm ">
              {filteredData.length === 0 && query !== "" ? (
                <div className="relative cursor-default select-none py-2 px-4 text-gray-700 dark:text-white">
                  Nothing found.
                </div>
              ) : (
                filteredData.map((person) => (
                  <Combobox.Option
                    key={person.id}
                    className={({ active }) =>
                      `relative cursor-default select-none py-2 pl-10 pr-4 ${
                        active
                          ? "bg-blue-500 text-white "
                          : "text-gray-900 dark:text-white"
                      }`
                    }
                    value={person}
                  >
                    {({ selected, active }) => (
                      <>
                        <span
                          className={`block truncate ${
                            selected ? "font-medium" : "font-normal"
                          }`}
                        >
                          {person.username}
                        </span>
                        {selected ? (
                          <span
                            className={`absolute inset-y-0 left-0 flex items-center pl-3 ${
                              active ? "text-white" : "text-blue-500"
                            }`}
                          >
                            {/* <CheckIcon className="h-5 w-5" aria-hidden="true" /> */}
                          </span>
                        ) : null}
                      </>
                    )}
                  </Combobox.Option>
                ))
              )}
            </Combobox.Options>
          </Transition>
        </div>
      </Combobox>
      {errorMsg && !selected.id && (
        <span className="text-red-600 capitalize">{`${name} is required!`}</span>
      )}
    </div>
  );
}
